import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import EmailInput from '../../common/EmailInput';

const EmailComponent = () => {
    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Email Input Showcase</h2>
                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <EmailInput
                                    name="primaryEmail"
                                    id="primaryEmailInput"
                                    required={true}
                                    layout="below"
                                    showHelp={true}
                                    helpText="Please enter your primary email."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<EmailInput
    name="primaryEmail"
    id="primaryEmailInput"
    required={true}
    layout="below"
    showHelp={true}
    helpText="Please enter your primary email."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <EmailInput
                                    name="businessEmail"
                                    id="businessEmailInput"
                                    required={true}
                                    layout="below"
                                    businessEmailOnly={true}
                                    showHelp={true}
                                    helpText="Please enter your business email."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<EmailInput
    name="businessEmail"
    id="businessEmailInput"
    required={true}
    layout="below"
    businessEmailOnly={true}
    showHelp={true}
    helpText="Please enter your business email."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <EmailInput
                                    name="optionalEmail"
                                    id="optionalEmailInput"
                                    required={false}
                                    layout="below"
                                    placeholder="Enter your optional email"
                                    showHelp={true}
                                    helpText="This email is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<EmailInput
    name="optionalEmail"
    id="optionalEmailInput"
    required={false}
    layout="below"
    placeholder="Enter your optional email"
    showHelp={true}
    helpText="This email is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <EmailInput
                                    name="secondaryEmail"
                                    id="secondaryEmailInput"
                                    required={true}
                                    layout="below"
                                    showHelp={true}
                                    helpText="Please enter your secondary email."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<EmailInput
    name="secondaryEmail"
    id="secondaryEmailInput"
    required={true}
    layout="below"
    showHelp={true}
    helpText="Please enter your secondary email."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default EmailComponent;
